import React from 'react';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import { useLanguage } from '../context/LanguageContext';
import useFooterAwareOffset from '../utils/useFooterAwareOffset';
import '../styles/quick-settings.css';

const QuickSettings = () => {
  const { language, themeMode, toggleThemeMode } = useLanguage();
  const isDark = themeMode === 'dark';
  const footerAwareBottom = useFooterAwareOffset({
    desktopBottom: 20,
    mobileBottom: 92,
    mobileBreakpoint: 860,
    extraLift: 12
  });
  const aria =
    language === 'en'
      ? isDark
        ? 'Switch to light mode'
        : 'Switch to dark mode'
      : isDark
        ? 'Cambiar a modo claro'
        : 'Cambiar a modo oscuro';

  return (
    <button
      type="button"
      className={`theme-fab ${isDark ? 'is-dark' : ''}`}
      onClick={toggleThemeMode}
      aria-label={aria}
      title={aria}
      style={{ bottom: `${footerAwareBottom}px` }}
    >
      <LightModeRoundedIcon className="theme-fab-icon sun" />
      <DarkModeRoundedIcon className="theme-fab-icon moon" />
    </button>
  );
};

export default QuickSettings;
